import React from 'react';
import { SvgImage } from './svg-image';
export var SvgImagePatternDefaultProps = {
  onLoad: function () {},
  encode: false
};
export var SvgImagePattern = function (props) {
  var url = props.url,
    width = props.width,
    height = props.height,
    encode = props.encode,
    onLoad = props.onLoad;
  // Create an ID based on the imageUrl
  var patternId = "pattern-".concat(url);
  return React.createElement("pattern", {
    id: patternId,
    patternUnits: "userSpaceOnUse",
    width: width * 1.5,
    height: height * 1.5
  }, React.createElement(SvgImage, {
    href: url,
    width: width,
    height: height
  }));
};
export default SvgImagePattern;